import { arrayOf, func, node, number, shape, string } from 'prop-types';
import React from 'react';
import { components } from 'react-select';

import Checkbox from '../Checkbox';

const SelectGroupHeading = components.GroupHeading;

function GroupHeading(props) {
  const { aggregateSelection } = props.selectProps;
  const { selected, options } =
    aggregateSelection.find(group => group.label === props.children) || {};
  return (
    <SelectGroupHeading {...props}>
      <Checkbox
        onChange={event => {
          const { onGroupSelect } = props.selectProps;

          onGroupSelect(props.children, event.target.checked);
        }}
        value={props.children}
        checked={selected > 0}
        indeterminate={selected > 0 && selected < options}
      />
      &nbsp;
      {props.children}
    </SelectGroupHeading>
  );
}

GroupHeading.propTypes = {
  children: node.isRequired,
  selectProps: shape({
    onGroupSelect: func,
    aggregateSelection: arrayOf(
      shape({
        label: string.isRequired,
        selected: number.isRequired,
        options: number.isRequired,
      }),
    ).isRequired,
  }).isRequired,
};

export default GroupHeading;
